// extracted by mini-css-extract-plugin
export var formContainer = "_ll-0";
export var message = "_ll-1";